<script lang="ts">
	import type { ComponentSectionsPartners } from '$lib/graphql/strapiApi';
	import * as Card from '$lib/components/ui/card';
	import { mode } from '$lib/state/global.svelte';

	let { content }: { content: ComponentSectionsPartners } = $props();
</script>

<div class="flex w-full flex-col items-center">
	<h1 class="mb-4 text-4xl font-bold">{content.title}</h1>
	{#if content.description}
		<p
			class="mb-8 inline text-center text-2xl font-normal [&_a:hover]:underline [&_a]:inline [&_a]:font-semibold"
		>
			{@html content.description}
		</p>
	{/if}
	<div class="flex flex-row flex-wrap justify-center gap-4">
		{#each content.companies.filter((x) => x?.partner) as partner}
			<Card.Root class="h-[75px] w-[200px]">
				<Card.Content class="flex h-[75px] items-center">
					{#if $mode === 'light'}
						<img class="w-full" src={partner?.logo?.url} alt={partner?.name} />
					{:else}
						<img
							class="w-full"
							src={partner?.darkLogo?.formats?.medium?.url ??
								partner?.darkLogo?.url ??
								partner?.logo?.formats?.medium?.url ??
								partner?.logo?.url}
							alt={partner?.name}
						/>
					{/if}
				</Card.Content>
			</Card.Root>
		{/each}
	</div>
</div>
